import { Component } from '@angular/core';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
    selector: 'app-toggle-switch-cell',
    templateUrl: './toggle-switch-cell.component.html',
    styleUrls: ['./toggle-switch-cell.component.scss'],
    standalone: false
})
export class ToggleSwitchCellComponent implements ICellRendererAngularComp {
  readOnly = false;
  cellParams = {
    readOnly: false,
    isActive: false,
  };

  readOnlyTooltipMessage = '';

  private params: ICellRendererParams | any;

  agInit(params: ICellRendererParams<any, any>): void {
    this.params = params;
    const dataParams = params?.colDef?.cellRendererParams;
    if (dataParams?.cellParams) {
      if (typeof dataParams.cellParams === 'function') {
        this.cellParams = dataParams.cellParams(params);
        this.readOnlyTooltipMessage = this.cellParams.readOnly ? dataParams?.readOnlyTooltipMessage : '';
      }
    }
  }

  toggleSwitch(e: MatSlideToggleChange): void {
    if (!this.cellParams.readOnly) {
      this.params?.clicked({
        params: this.params,
        cellParams: this.cellParams,
        isActive: e.checked,
        callBack: (isActive: boolean) => {
          e.source.checked = isActive;
        },
      });
    }
  }

  refresh() {
    return false;
  }
}
